

import React from "react";
import { Modal, ModalBody } from "reactstrap";
import { Table, Button } from "react-bootstrap";
import "../../assets/scss/filteredModal.css"

const FilteredDataModal = ({ isOpen, toggleModal, filteredData, columnList }) => {
  
  return (
    <Modal isOpen={isOpen} toggle={toggleModal} style={{ overflow: "visible" }}>
      <ModalBody>
        <h4>Accuracy Data</h4>

        {false && <div className="modal-scrollable-content"> {/* Add a wrapper for scrollable content */}
          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  {columnList.map((col, index) => (
                    <th key={index}>{col.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredData.length > 0 ? (
                  filteredData.map((item, index) => (
                    <tr key={index}>
                      {columnList.map((col, colIndex) => (
                        <>
                        <td key={colIndex}>{item[col.field]}{col.field === "checkCutoff" || col.field === "percent" ? "%" : null}</td>

                        </>
                      ))}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columnList.length}>No data available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>}
        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", width: "100%", marginTop:20 , marginBottom:10 }}>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" , fontSize:14}}>
            <div><strong>Unique Name:</strong></div>
            <span>{filteredData[0]?.uniqueProductNameAccuracy+ "%" || "0%"}</span>
          </div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center", fontSize:14 }}>
            <div><strong>Recheck:</strong></div>
            <span>{filteredData[0]?.needsToRecheck + '%' || "0%"}</span>
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", width: "100%", marginTop:20 , marginBottom:10 }}>
        <div style={{ display: "flex", gap: "8px", alignItems: "center" , fontSize:14}}>
            <div><strong> Total Exporter count:</strong></div>
            <span>{filteredData[0]?.totalExporter || "-"}</span>
          </div>
          <div style={{ display: "flex", gap: "8px", alignItems: "center" , fontSize:14}}>
            <div><strong> Total Importer count:</strong></div>
            <span>{filteredData[0]?.totalImporter || "-"}</span>
          </div>
          </div>

        <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", width: "100%", marginTop:20 , marginBottom:10 }}>
          <div style={{ display: "flex", gap: "8px", alignItems: "center", fontSize:14 }}>
              <div><strong>Exporter accuracy:</strong></div>
              <span>{filteredData[0]?.accuratExporter + '%' || "0%"}</span>
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center", fontSize:14 }}>
              <div><strong>Importer accuracy:</strong></div>
              <span>{filteredData[0]?.accuratImporter + '%' || "0%"}</span>
            </div>
        </div>
        <Button onClick={toggleModal} style={{ marginTop: "10px" }}>
          Close
        </Button>
      </ModalBody>
    </Modal>
  );
};

export default FilteredDataModal; 